<div class="detail-container row gy-4 w-100">
  <div class="col-12 col-md-6">
    <!-- SWIPER IMAGE CAROUSEL -->
    <div class="image-carousel-container">
      <swiper
        [slidesPerView]="1"
        [navigation]="true"
        [slidesPerGroup]="1"
        class="swiper"
      >
        <ng-template swiperSlide *ngIf="product?.images.length == 0">
          <img class="image-carousel" [src]="defaultImage" alt="">
        </ng-template>
        <ng-template ngIf="product?.images.length != 0" swiperSlide *ngFor="let image of product?.images" >
          <img class="image-carousel" [src]="image.url" [alt]="product?.name">
        </ng-template>
      </swiper>
    </div>
  </div>
  <div class="col-12 col-md-6 d-flex flex-column gap-3">
    <!-- NAME AND PRICE -->
    <div>
      <h2>{{product?.name}}</h2>
      <p>
        <span [ngClass]="{'text-decoration-line-through': shoppingDiscount != 0}" class="fs-md">{{product?.itemPrices?.price | currency}}</span>
        <span [hidden]="shoppingDiscount != 0">
          <ng-container *ngIf="product?.itemPrices?.tax == 0; else IVANotIncluded">
            <ng-container *ngIf="!product?.itemPrices?.nonTaxable">
              (IVA incluido)
            </ng-container>
          </ng-container>
          <ng-template #IVANotIncluded>
            ({{product?.itemPrices?.tax * 100}}% IVA)
          </ng-template>
        </span>
      </p>
      <p class="text-danger fs-lg" *ngIf="shoppingDiscount != 0">
        {{product?.itemPrices?.priceWithDiscount | currency}}
        <span>
          <ng-container *ngIf="product?.itemPrices?.tax == 0; else IVANotIncluded">
           <ng-container *ngIf="!product?.itemPrices?.nonTaxable">
              (IVA incluido)
            </ng-container>
          </ng-container>
          <ng-template #IVANotIncluded>
            ({{product?.itemPrices?.tax * 100}}% IVA)
          </ng-template>
        </span>

      </p>
    </div>

    <!-- DESCRIPTION AND CHARACTERISTICS -->
    <mat-tab-group>
      <mat-tab label="Descripción">
        <p class="w-100 m-0 py-2">{{product?.description}}</p>
      </mat-tab>
      <mat-tab label="Características">
        <div class="row w-100 m-0 py-2" *ngFor="let item of product?.specList">
          <div class="col-5 p-0 align-self-center text-left">
            <p><strong>{{item.name}}</strong>:</p>
          </div>
          <div class="col-7 p-0 align-self-center text-left">
            <p>{{item.value}}</p>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <mat-divider></mat-divider>

    <ng-container *ngIf="product && !isAccesoryProductType() && !isSetupProduct">
      <!-- DENTAL MONITORING -->
      <div class="d-flex flex-column gap-2">
        <img class="dental-monitoring-image" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/dental_monitoring.png" alt="Dental monitoring logo">
        <ng-container *ngIf="product?.hasDentalMonitoring; else hasNotDentalMonitoring">
          <p>Tu caso <strong>incluye Dental Monitoring</strong> sin costo, ¿quieres que lo enviemos?</p>
          <mat-checkbox [value]="true" [checked]="addDentalMonitoring" (change)="onAddDentalMonitoringChange($event)">Si</mat-checkbox>
          <mat-checkbox [value]="false" [checked]="!addDentalMonitoring" (change)="onAddDentalMonitoringChange($event)">No</mat-checkbox>
        </ng-container>
        <ng-template #hasNotDentalMonitoring>
          <mat-checkbox class="d-block" [checked]="addDentalMonitoring" (change)="addDentalMonitoring = !addDentalMonitoring">Agregar por: <strong>{{product?.itemPrices?.priceExtraDentalMonitoring | currency}}</strong></mat-checkbox>
        </ng-template>
      </div>
      <mat-divider></mat-divider>

      <!-- COMPLEX CASE -->
      <div class="d-flex flex-column gap-2" *ngIf="currentEntity.allowComplexCase">
        <p><strong>¿Este caso es cierre espacios de extracciones o quirúrgico?:</strong></p>
        <mat-checkbox [value]="true" [checked]="addIsComplexCase" (change)="onAddIsComplexCaseChange($event)">Si +{{product?.itemPrices?.priceComplexCase | currency}}</mat-checkbox>
        <mat-checkbox [value]="false" [checked]="!addIsComplexCase" (change)="onAddIsComplexCaseChange($event)">No</mat-checkbox>
      </div>
      <mat-divider *ngIf="currentEntity.allowComplexCase"></mat-divider>

      <!-- ADDITIONAL ALIGNERS -->
      <div class="d-flex flex-column gap-2">
        <p><strong>Alineadores Adicionales</strong></p>
        <ng-container *ngIf="!product?.hasUnlimitedAligners; else hasUnlimitedAligners">
          <mat-checkbox class="d-block" [checked]="addAdditionalAligners" (change)="addAdditionalAligners = !addAdditionalAligners">Agregar por: <strong>{{product?.itemPrices?.priceExtraAligner | currency}} c/u</strong></mat-checkbox>
          <app-custom-input-number #customInputQuantityExtraAligners [counter]="quantityExtraAligners" [minValue]="1" (valueChanged)="quantityExtraAligners = $event"></app-custom-input-number>
        </ng-container>
        <ng-template #hasUnlimitedAligners>
          <p><strong>¡Este producto tiene alineadores ilimitados!</strong></p>
        </ng-template>
      </div>
    </ng-container>

    <div class="mt-3 d-flex flex-column gap-2">
      <h5><strong>Total: {{getProductTotal | currency}} </strong></h5>
      <p>I.V.A. Incluido, excepto en productos o servicios no gravables</p>
    </div>

    <button class="button secondary-button p-3 lh-1" style="width:fit-content" (click)="onClickAddProductToShoppingCart()">
      <ng-container *ngIf="getCaseId; else hasNotCaseId">
        Agregar a este caso
      </ng-container>
      <ng-template #hasNotCaseId>
        Agregar al carrito
      </ng-template>
    </button>
  </div>
</div>

<app-dialog #dentalMonitoringDialog [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onSetAddDentalMonitoring.bind(this)" confirmButtonText="Incluir" confirmButtonIcon="check" cancelButtonText="Eliminar" cancelButtonIcon="close" confirmButtonClass="button primary-button">
  <div>
    <div class="mx-auto d-flex flex-column gap-3 px-4">
      <h3>¡Dental Monitoring incluido!</h3>
      <p>
        Pregúntanos para conocer como <strong>DentalMonitoring</strong> puede facilitar tu consulta y tus tratamientos
      </p>
      <p>¿Deseas eliminar Dental Monitoring?</p>
    </div>
  </div>
</app-dialog>

<app-dialog #confirmDeleteCurrentCart [enableCloseDialogButton]="true" [preventCloseFromBackDrop]="true" [hasCallBack]="true" [callBackFunction]="onAddProductToShoppingCart.bind(this)" confirmButtonText="Aceptar" confirmButtonClass="button danger-button rounded" height="60%" width="90%">
  <div>
    <div class="w-50 mx-auto d-flex flex-column gap-5 p-4">
      <h2 class="col text-center">Para continuar con el proceso de compra, es necesario eliminar los productos del Carrito<strong> ¿Desea continuar?</strong></h2>
      <img class="w-50 mx-auto" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/undraw-notify.svg" alt="Notificación imagen">
    </div>
  </div>
</app-dialog>
